module.exports = __webpack_public_path__ + "img/35.3.TP.3c4a952e.png";